import { PublicationSetting } from 'data/generated/graphql';
import { AllessehContent } from 'hooks/useAllessehContentQuery';
import { ContentConstantsResponse, modifyPublicationMapResult } from 'hooks/useContentConstants';

export function isAltSummDisabled(
  content: AllessehContent,
  currentProperty: string,
  publicationSetting?: PublicationSetting,
  contentConstants?: ContentConstantsResponse
) {
  const publicationMap = contentConstants?.publicationMap;
  const isCommerceProduct = content.data.attributes.type === 'commerceproduct';
  const editableExternalPublications = publicationSetting?.editableExternalPublications ?? [];
  const isLiveCoverageCard =
    content.data.attributes.section_type !== 'stack' &&
    content.data.attributes.upstream_origin?.includes('Live Coverage');
  if (!publicationMap) {
    return false;
  }

  const currentProduct = modifyPublicationMapResult(publicationMap, content.data.attributes.product);
  return (
    isCommerceProduct ||
    isLiveCoverageCard ||
    (currentProperty !== currentProduct &&
      !editableExternalPublications.find((property) => currentProduct === property))
  );
}
